<template>
  <b-sidebar
    title="Main Menu"
    :body-class="'sidebarbodystyle'"
    v-model="drawer"
    max-width="600"
    class="mainSidebar"
    :right="right"
  >
    <b-row>
      <b-col style cols="12">
        <b-list-group>
          <div v-for="menu in menus" :key="menu.name">
            <b-list-group-item
              v-b-toggle="menu.id"
              @click="routeChange(menu)"
              class="d-flex cursor-pointer"
            >
              <p>
                <span>
                  <font-awesome-icon :icon="menu.icon" />
                </span>
                {{ ' ' + menu.name }}
              </p>
            </b-list-group-item>
            <div>
              <b-collapse :id="menu.id" v-for="children in menu.children" :key="children.name">
                <b-list-group-item class="text-left bg-light">
                  <p>
                    <span>
                      <font-awesome-icon :icon="children.icon" />
                    </span>
                    {{' ' + children.name}}
                    <!-- Sub Item 1 -->
                  </p>
                </b-list-group-item>
              </b-collapse>
            </div>
          </div>
        </b-list-group>
      </b-col>
    </b-row>
  </b-sidebar>
</template>
<script>
import { EventBus } from "@/event-bus.js";

export default {
  props: {
    menus: Array,
    right: Boolean
  },
  name: "SideBar",
  data() {
    return {
      drawer: false
    };
  },
  methods: {
    openDrawer() {
      this.drawer = !this.drawer;
    },
    routeChange(menu) {
      if (this.$route.path !== menu.path || this.$route.path == "/") {
        this.$router.push(menu.path);
      }
    }
  },
  created() {
    EventBus.$on("onClickOpenDrawer", value => {
      this.openDrawer();
    });
    EventBus.$on("onClickOpenHeaderDrawer", value => {
      this.drawer = value;
    });
  }
};
</script>
<style>
.mainSidebar {
  z-index: 999 !important;
}
.sidebarbodystyle {
  overflow-x: hidden;
}
</style>
